import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, ClockIcon, InfinityIcon } from 'lucide-react';
export function PriceBlock() {
  return <section id="precio" className="bg-off-white py-16 px-6" data-id="element-124">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-125">
        <div className="bg-white p-8 md:p-12 rounded-lg shadow-2xl border-4 border-gold" data-id="element-126">
          <h2 className="font-serif text-3xl md:text-4xl mb-6 text-center text-navy" data-id="element-127">
            No Necesitas un Abogado de $200 la Hora
          </h2>
          <p className="text-lg text-gray-700 text-center mb-8" data-id="element-128">
            Todo el Kit de Supervivencia: Despido/Renuncia está disponible hoy
            por un pago único.
          </p>

          <div className="text-center mb-8" data-id="element-129">
            <div className="inline-block" data-id="element-130">
              <div className="inline-block bg-red-600 text-white font-bold text-sm px-3 py-1 rounded-full mb-3" data-id="element-131">
                -84% DESCUENTO
              </div>
              <div className="text-gray-500 line-through text-2xl mb-2" data-id="element-132">
                $39 USD
              </div>
              <div className="text-6xl md:text-7xl font-bold text-navy mb-2" data-id="element-133">
                $6.39
              </div>
              <div className="text-xl text-gray-600" data-id="element-134">USD · Pago único</div>
            </div>
          </div>

          <div id="cta-kit" className="mb-8" data-id="element-135">
            <CTAButton onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'PageView');
            }
            window.open('https://impulsopractico.com/cart/51198301405499:1', '_blank');
          }} className="w-full text-xl py-6" data-id="element-136">
              ¡QUIERO EL KIT Y PROTEGER MI FUTURO AHORA!
            </CTAButton>
          </div>

          <div className="grid md:grid-cols-3 gap-6 text-center" data-id="element-137">
            <div className="flex flex-col items-center" data-id="element-138">
              <ShieldCheckIcon className="w-10 h-10 text-gold mb-2" data-id="element-139" />
              <span className="text-sm font-semibold text-gray-700" data-id="element-140">
                Pago 100% Seguro
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-141">
              <ClockIcon className="w-10 h-10 text-gold mb-2" data-id="element-142" />
              <span className="text-sm font-semibold text-gray-700" data-id="element-143">
                Acceso Inmediato
              </span>
            </div>
            <div className="flex flex-col items-center" data-id="element-144">
              <InfinityIcon className="w-10 h-10 text-gold mb-2" data-id="element-145" />
              <span className="text-sm font-semibold text-gray-700" data-id="element-146">
                Tuyo Para Siempre
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}